import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import environment from 'environments/environment';
import { parseFilenameFromContentDisposition } from '../utils';

interface FileResponse {
    blob: Blob;
    fileName: string;
}

@Injectable()
export class DocumentService {
    private readonly apiBaseUrl = `${environment.api.baseUrl}/portal/documents`;
    constructor(private readonly httpClient: HttpClient) {}

    generateAmortisationSchedule(applicationGuid: string, requestedDate: Date) {
        return this.httpClient
            .post(
                `${this.apiBaseUrl}/amortisation-schedule/${applicationGuid}`,
                { requestedDate },
                { observe: 'response', responseType: 'blob' }
            )
            .pipe(
                map(response => {
                    return {
                        blob: response.body,
                        fileName:
                            parseFilenameFromContentDisposition(response.headers.get('Content-Disposition')) ||
                            'amortisation-schedule.pdf'
                    } as FileResponse;
                })
            );
    }
}
